(function () {
  'use strict';

  var initialized = false;

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function getProductRootFromModal(modal) {
    var modalId = modal && modal.id;
    if (!modalId) return null;
    return document.querySelector(
      'product-info[data-size-chart-modal-id="' +
        cssEscape(modalId) +
        '"], product-info[data-shipping-policy-modal-id="' +
        cssEscape(modalId) +
        '"]'
    );
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
    return String(value).replace(/["\\]/g, '\\$&');
  }

  function pauseSizeChartVideos(modal) {
    if (!modal) return;
    modal.querySelectorAll('[data-size-chart-video]').forEach(function (video) {
      video.pause();
    });
  }

  function loadSizeChartVideo(modal) {
    if (!modal || !modal.id || modal.id.indexOf('size-chart-modal') !== 0) return;

    modal.querySelectorAll('[data-size-chart-video]').forEach(function (video) {
      if (!video.hasAttribute('data-video-loaded')) {
        video.querySelectorAll('source[data-src]').forEach(function (source) {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
        });
        video.load();
        video.setAttribute('data-video-loaded', 'true');
      }

      video.play().catch(function () {});
    });
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove('show');
    pauseSizeChartVideos(modal);
    document.body.style.overflow = '';
  }

  function openModal(modal) {
    if (!modal) return;

    if (modal.classList.contains('modal--product-info') && modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    modal.classList.add('show');
    document.body.style.overflow = 'hidden';
    loadSizeChartVideo(modal);
  }

  function bindCloseHandlers(modal) {
    if (!modal || modal.hasAttribute('data-modal-close-bound')) return;
    modal.setAttribute('data-modal-close-bound', 'true');

    var closeButton = modal.querySelector('.modal-close');
    if (closeButton) {
      closeButton.addEventListener('click', function () {
        closeModal(modal);
      });
    }

    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal(modal);
    });
  }

  function prepareProductInfo(productInfo) {
    if (!productInfo) return;

    var sizeChartModalId = productInfo.dataset.sizeChartModalId;
    var shippingPolicyModalId = productInfo.dataset.shippingPolicyModalId;
    var sizeChartModal = sizeChartModalId ? document.getElementById(sizeChartModalId) : null;
    var shippingPolicyModal = shippingPolicyModalId ? document.getElementById(shippingPolicyModalId) : null;
    var productInfoModals = productInfo.querySelectorAll('.modal--product-info');

    if (shippingPolicyModal) {
      productInfo.querySelectorAll('a[href*="shipping-policy"]').forEach(function (link) {
        link.setAttribute('data-modal-trigger', shippingPolicyModal.id);
        link.setAttribute('aria-haspopup', 'dialog');
        link.setAttribute('data-shipping-modal-link', 'true');
      });
    }

    if (sizeChartModalId) {
      document.querySelectorAll('[data-modal-trigger="' + cssEscape(sizeChartModalId) + '"]').forEach(function (link) {
        link.setAttribute('data-modal-initialized', 'true');
      });
    }

    bindCloseHandlers(sizeChartModal);
    bindCloseHandlers(shippingPolicyModal);
    productInfoModals.forEach(bindCloseHandlers);

    if (!productInfo.hasAttribute('data-product-modal-observer-bound')) {
      productInfo.setAttribute('data-product-modal-observer-bound', 'true');
      new MutationObserver(function () {
        prepareProductInfo(productInfo);
      }).observe(productInfo, {
        childList: true,
        subtree: true,
      });
    }
  }

  function openVideoOverlay(video) {
    var overlay = document.createElement('div');
    overlay.style.cssText =
      'position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.8);z-index:9999;display:flex;align-items:center;justify-content:center;padding:20px;';

    var closeButton = document.createElement('button');
    closeButton.innerHTML = '&times;';
    closeButton.setAttribute('aria-label', 'Close video');
    closeButton.style.cssText =
      'position:absolute;top:30px;right:30px;background:rgba(255,255,255,.9);border:none;color:#000;font-size:24px;width:40px;height:40px;border-radius:50%;cursor:pointer;z-index:10000;font-weight:bold;';

    var clone = video.cloneNode(true);
    clone.style.cssText = 'max-width:90%;max-height:80%;width:auto;height:auto;border-radius:8px;box-shadow:0 4px 20px rgba(0,0,0,.5);';
    clone.controls = true;
    clone.autoplay = true;

    clone.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
    });

    function removeOverlay(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      overlay.remove();
    }

    closeButton.addEventListener('click', removeOverlay);
    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) removeOverlay(event);
    });

    overlay.appendChild(closeButton);
    overlay.appendChild(clone);
    document.body.appendChild(overlay);
  }

  function requestFullscreen(video) {
    if (!video) return;
    if (video.requestFullscreen) video.requestFullscreen();
    else if (video.webkitRequestFullscreen) video.webkitRequestFullscreen();
    else if (video.msRequestFullscreen) video.msRequestFullscreen();
  }

  function hydrateDeferredMedia(element) {
    if (!element || element.hasAttribute('data-gallery-media-loaded')) return;

    if (element.dataset.src) {
      element.src = element.dataset.src;
      element.removeAttribute('data-src');
    }

    if (element.dataset.srcset) {
      element.srcset = element.dataset.srcset;
      element.removeAttribute('data-srcset');
    }

    element.setAttribute('data-gallery-media-loaded', 'true');
  }

  function hydrateGalleryScope(scope) {
    if (!scope) return;
    scope.querySelectorAll('[data-defer-gallery-media]').forEach(hydrateDeferredMedia);
  }

  function observeDeferredGalleryMedia() {
    var media = document.querySelectorAll('[data-defer-gallery-media]');
    if (!media.length) return;

    if (!('IntersectionObserver' in window)) {
      media.forEach(hydrateDeferredMedia);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          hydrateDeferredMedia(entry.target);
        });
      },
      { rootMargin: '350px 350px' }
    );

    media.forEach(function (element) {
      observer.observe(element);
    });
  }

  function init() {
    document.querySelectorAll('product-info').forEach(prepareProductInfo);
    observeDeferredGalleryMedia();

    if (initialized) return;
    initialized = true;

    document.addEventListener(
      'click',
      function (event) {
	        var trigger = event.target.closest('[data-modal-trigger]');
	        if (trigger) {
          var modal = document.getElementById(trigger.getAttribute('data-modal-trigger'));
          if (!modal) return;

          event.preventDefault();
          event.stopPropagation();
          openModal(modal);
          return;
	        }

	        var galleryControl = event.target.closest('.product__media-wrapper, media-gallery, .thumbnail-slider, .slider-buttons');
	        if (galleryControl) {
	          hydrateGalleryScope(galleryControl.closest('media-gallery') || galleryControl);
	        }

	        var sizeChartVideo = event.target.closest('#size-chart-modal video, [id^="size-chart-modal"] video');
        if (sizeChartVideo) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          openVideoOverlay(sizeChartVideo);
          return;
        }

        var poster = event.target.closest('.deferred-media__poster');
        if (poster) {
          var container = poster.closest('deferred-media');
          window.setTimeout(function () {
            requestFullscreen(container && container.querySelector('video'));
          }, 250);
          return;
        }

        var video = event.target.closest('video');
        if (video && !getProductRootFromModal(video.closest('.modal'))) {
          requestFullscreen(video);
        }
      },
      true
    );

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('.modal.show').forEach(closeModal);
    });

	    document.addEventListener('shopify:section:load', function (event) {
	      event.target.querySelectorAll('product-info').forEach(prepareProductInfo);
	      observeDeferredGalleryMedia();
	    });
  }

  onReady(init);
})();
